/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import has from 'lodash/has';
import isArray from 'lodash/isArray';
import keys from 'lodash/keys';
import uniq from 'lodash/uniq';

export const isShallowEqual = <T, U>(a: T, b: U, debug = false): boolean => {
	if (isArray(a) && isArray(b)) {
		if (a.length !== b.length) {
			if (debug) {
				// oxlint-disable-next-line no-console
				console.log('arrays not of equal length', a, b);
			}
			return false;
		}

		return a.every((value, index) => {
			if (value !== b[index]) {
				if (debug) {
					// oxlint-disable-next-line no-console
					console.log(`[${index}]`, value, '!=', b[index]);
				}
				return false;
			}
			return true;
		});
	}

	return uniq([...keys(a), ...keys(b)]).every((key) => {
		if (!has(b, key)) {
			if (debug) {
				// oxlint-disable-next-line no-console
				console.log('property missing in [arg2]', key);
			}
			return false;
		}
		if (!has(a, key)) {
			if (debug) {
				// oxlint-disable-next-line no-console
				console.log('property missing in [arg1]', key);
			}
			return false;
		}
		if (!Object.is(a[key], b[key])) {
			if (debug) {
				/* oxlint-disable-next-line no-console */
				console.log(`[${key}]`, a[key], '!=', b[key]);
			}
			return false;
		}
		return true;
	});
};
